import React, { FC } from 'react';
import { Timeline } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Location } from '~/types';
import { getDaysOfWeek } from './WorkingHoursInput';
import { Longdash } from '~/utils';
import { useFirstDayOfWeek } from '~/hooks/useHandbook';

interface Props {
  record: Location['schedule'];
}

const WorkingHoursField: FC<Props> = (props) => {
  const { record } = props;
  const [t] = useTranslation('locations');
  const { data: firstDayOfWeek } = useFirstDayOfWeek();

  if (!record) return null;
  return (
    <Timeline mode="left">
      {getDaysOfWeek(firstDayOfWeek).map((day) => {
        return (
          <TimelineItem
            key={day}
            label={t(`translation:${day}`)}
            color={record[day] ? 'blue' : 'gray'}
          >
            {record[day]?.workingHours?.map(({ from, to }, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <div key={index.toString()}>{`${from} ${Longdash} ${to}`}</div>
              );
            }) || Longdash}
          </TimelineItem>
        );
      })}
    </Timeline>
  );
};

const TimelineItem = styled(Timeline.Item)`
  .ant-timeline-item-label,
  .ant-timeline-item-content {
    color: ${({ color }) => (color === 'gray' ? 'rgba(0, 0, 0, 0.25)' : 'unset')};
  }
`;

export default WorkingHoursField;
